import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';

import { marketingApi as api } from 'api/marketing';
import { FormComponent, Notifications } from 'shared';

const MIN_CREDIT_AMOUNT = 10;
const MAX_CREDIT_AMOUNT = 200;

function CreateReferral() {
    const [error, setError] = useState(null);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [newCustCredit, setNewCustCredit] = useState(null);
    const [advocateCredit, setAdvocateCredit] = useState(null);
    const [minimumOrderValue, setMinimumOrderValue] = useState(null);
    const [termsAndConditions, setTermsAndConditions] = useState(null);

    const formFields = [
        {
            name: 'newCustValue',
            inputElement: 'textField',
            label: 'New Customer Credit Dollars',
            gridValue: 6,
            inputProps: {
                required: true,
                type: 'number',
                step: '1',
                min: MIN_CREDIT_AMOUNT,
                max: MAX_CREDIT_AMOUNT,
                placeholder: `Enter amount between $${MIN_CREDIT_AMOUNT}-$${MAX_CREDIT_AMOUNT}`,
            },
        },
        {
            name: 'referrerValue',
            inputElement: 'textField',
            label: 'Advocate Credit Dollars',
            gridValue: 6,
            inputProps: {
                required: true,
                type: 'number',
                step: '1',
                min: MIN_CREDIT_AMOUNT,
                max: MAX_CREDIT_AMOUNT,
                placeholder: `Enter amount between $${MIN_CREDIT_AMOUNT}-$${MAX_CREDIT_AMOUNT}`,
            },
        },
        {
            name: 'minimumOrderValue',
            inputElement: 'textField',
            label: 'Minimum Spend',
            gridValue: 6,
            inputProps: { required: true },
        },
        {
            name: 'termsAndConditionsValue',
            inputElement: 'textField',
            label: 'Terms & Conditions',
            gridValue: 6,
            inputProps: { required: false },
        },
    ];

    const getReferralRewards = async () => {
        const response = await api.getReferralRewards();
        if (response.status === false) {
            setNotification({
                text: `Unable to determine current referral credit rewards ${response.msg}`,
                level: 'error',
            });
            return;
        }

        setNewCustCredit(response.data.referralRewards.newCustValue);
        setAdvocateCredit(response.data.referralRewards.referrerValue);
        setTermsAndConditions(response.data.referralRewards.termsAndConditions);
        setMinimumOrderValue(response.data.referralRewards.minimumOrderValue);
    };

    useEffect(() => {
        getReferralRewards();
    }, []);

    return (
        <div>
            <h1>Current Referral Rewards: </h1>
            <Notifications options={notification} />
            {}
            <div style={{ outline: 0, backgroundColor: 'white' }}>
                <div>
                    {' '}
                    <h3 style={{ display: 'inline-block' }}>Current new customer credit: </h3>{' '}
                    <span id="CustomerCredit">${newCustCredit}</span>{' '}
                </div>
                <div>
                    {' '}
                    <h3 style={{ display: 'inline-block' }}>Current advocate credit: </h3>{' '}
                    <span id="AdvocateCredit">${advocateCredit}</span>{' '}
                </div>
                <div>
                    {' '}
                    <h3 style={{ display: 'inline-block' }}>Current minimum order value: </h3>{' '}
                    <span id="MinimumOrderValue">${minimumOrderValue}</span>{' '}
                </div>
                <div>
                    {' '}
                    <h3 style={{ display: 'inline-block' }}> Current terms and conditions: </h3>{' '}
                    {termsAndConditions}{' '}
                </div>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        // Validate credit amounts are between MIN_CREDIT_AMOUNT and MAX_CREDIT_AMOUNT
                        const newCustValue = Number(formData.newCustValue);
                        const referrerValue = Number(formData.referrerValue);

                        if (newCustValue < MIN_CREDIT_AMOUNT || newCustValue > MAX_CREDIT_AMOUNT) {
                            setNotification({
                                text: `New customer credit must be between $${MIN_CREDIT_AMOUNT} and $${MAX_CREDIT_AMOUNT}`,
                                level: 'error',
                            });
                            return;
                        }

                        if (referrerValue < MIN_CREDIT_AMOUNT || referrerValue > MAX_CREDIT_AMOUNT) {
                            setNotification({
                                text: `Advocate credit must be between $${MIN_CREDIT_AMOUNT} and $${MAX_CREDIT_AMOUNT}`,
                                level: 'error',
                            });
                            return;
                        }

                        const response = await api.updateReferralRewards(formData);
                        if (response.status === false) {
                            setNotification({
                                text: `Unable to update referral credit rewards ${response.msg}`,
                                level: 'error',
                            });
                            return;
                        }

                        setNotification({ text: 'Success!', level: 'success' });
                        resetForm();
                        getReferralRewards();
                    }}
                />
                {error && <div style={{ color: 'red' }}>{error}</div>}
            </div>
        </div>
    );
}

export { CreateReferral };
